module.exports = {
  title: 'vue-starter-kit',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,
  vconsole: true,
  needPageTrans: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
};